import React, { useState } from 'react'
import UsersListAutocomplete from '../admin/UsersListAutocomplete';
import { Button, Grid, Paper, Typography } from '@mui/material';
import ATSnackbar from '../layout/ATSnackbar';
import MultipleUserSelect from '../admin/manual-buy/MultipleUserSelect';
import AllOrMultiUserSelect from '../util/AllOrMultiUserSelect';

const CopyUserStrategies = ({ user }) => {
    const [selectedUsers, setSelectedUsers] = useState({
        sourceUserId: '',
        destinationUserIds: []
    })

    const [notification, setNotification] = useState({
        open: false,
        message: ''
    })

    const [allOrSelected, setAllOrSelected] = useState('ALL');

    const handleChange = (event) => {
        setAllOrSelected(event.target.value);
        // For ALL, users should be empty
        setSelectedUsers(prev => ({ ...prev, destinationUserIds: [] }));
    };

    const handleChangeSourceUser = (selectedUserObj) => {
        setSelectedUsers(prev => ({ ...prev, sourceUserId: selectedUserObj?.id }));
    };
    const handleChangeDestinationUser = (selectedUserObj) => {
        if (!selectedUserObj) {
            setSelectedUsers(prev => ({ ...prev, destinationUserIds: [] }));
        } else if (Array.isArray(selectedUserObj)) {
            setSelectedUsers(prev => ({ ...prev, destinationUserIds: selectedUserObj.map(u => u.id) }));
        } else {
            setSelectedUsers(prev => ({ ...prev, destinationUserIds: [selectedUserObj.id] }));
        }
    };

    const onSubmit = () => {
        if (selectedUsers.sourceUserId === '') {
            showNotification('Please select source user');
            return;
        }
        fetch('/algo-trading/api/admin/strategies/copy-to-user',
            {
                method: 'post',
                headers: { 'Authorization': user?.credential, 'Content-Type': 'application/json' },
                body: JSON.stringify(selectedUsers),
            }
        ).then(r => {
            if (r.status !== 201) {
                showNotification('Error copying strategies')
                return
            }
            r.text()
                .then(value => {
                    showNotification(value)
                })
        }
        ).catch(error => {
            console.log(error);
            showNotification('Error copying strategies')
        });
    }

    const showNotification = message => setNotification({ open: true, message })


    return (
        <Paper elevation={2} component={Grid} item xs={12} paddingY={5}>
            {notification.open && <ATSnackbar message={notification.message} open={notification.open} setOpen={setNotification} severity={'warning'} />}

            <Grid item lg={12} paddingY={2}>
                <Typography variant='h6'>Copy user strategies</Typography>
            </Grid>
            <Grid container alignItems='center'>
                <Grid item lg={3} md={4} sm={4} xs={12} padding={1}>
                    <Typography>From user</Typography>
                    <UsersListAutocomplete loggedInUser={user} selectedUser={selectedUsers.sourceUserId} setSelectedUser={handleChangeSourceUser} />
                </Grid>
                <Grid item lg={5} md={4} sm={4} xs={12} padding={1}>
                    <AllOrMultiUserSelect
                        title="Copy to Users"
                        user={user}
                        allOrSelected={allOrSelected}
                        setAllOrSelected={handleChange}
                        selectedUsers={selectedUsers.destinationUserIds}
                        setSelectedUsers={handleChangeDestinationUser}
                    />
                </Grid>
                <Grid item lg={3} md={4} sm={4} xs={12} padding={1}>
                    <Button onClick={onSubmit} variant='contained'>Copy</Button>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default CopyUserStrategies